import {
  FETCH_CUSTOMER_LIST_PENDING,
  FETCH_CUSTOMER_LIST_REJECTED,
  FETCH_CUSTOMER_LIST_FULFILLED
} from "../constants/customerList";

const initialState = {
  pending: false,
  customers: [],
  error: {},
  count: 0
};

export const customerList = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CUSTOMER_LIST_PENDING:
      return { ...state, pending: true, error: [] };

    case FETCH_CUSTOMER_LIST_REJECTED:
      return { ...state, pending: false, error: action.error };

    case FETCH_CUSTOMER_LIST_FULFILLED:
      return {
        ...state,
        customers: action.response.results,
        count: action.response.count,
        pending: false,
        error: []
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/customerList.js